export const defaultLocale = 'en-us';
export const defaultTimeZoneId = 'UTC';
export const isAmPm = (locale) => new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).resolvedOptions().hour12;
export const getDeviceTimeZoneId = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || defaultTimeZoneId;
    }
    catch (e) {
        console.warn('Could not resolve Intl user timezone');
        return defaultTimeZoneId;
    }
};
export const extractLanguage = (locale) => locale?.split(/[-_]/)[0];
export const getLanguageFromLocale = (locale) => {
    const language = extractLanguage(locale);
    return isLanguageBabelSupported(language) ? language : DEFAULT_LANGUAGE;
};
export const getCountryFromLocale = (locale) => locale?.split('-')[1];
export const isRtlLanguage = (language = DEFAULT_LANGUAGE) => ['ar', 'arc', 'dv', 'fa', 'ha', 'he', 'khw', 'ks', 'ku', 'ps', 'ur', 'yi'].includes(extractLanguage(language));
export const DEFAULT_LANGUAGE = 'en';
export const isLanguageBabelSupported = (language) => SUPPORTED_BABEL_LANGUAGES.includes(extractLanguage(language));
/**
 * @deprecated The list should not be used outside this package
 */
export const SUPPORTED_BABEL_LANGUAGES = [
    'ar',
    'bg',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'en',
    'es',
    'fi',
    'fr',
    'he',
    'hi',
    'hr',
    'hu',
    'id',
    'it',
    'ja',
    'ko',
    'lt',
    'lv',
    'ms',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sl',
    'sv',
    'th',
    'tl',
    'tr',
    'uk',
    'vi',
    'zh',
];
